import { FilterParam } from '../types/filters';

export const getAppConsistentParams = (searchString: string) => {
  const searchParams = new URLSearchParams(searchString);
  const newSearchParams = new URLSearchParams();
  Object.values(FilterParam).forEach((param) => {
    if (searchParams.get(param)) {
      newSearchParams.append(param, searchParams.get(param) as string);
    }
  });
  return newSearchParams;
};
